'use client'

import { SliderArrows } from './SliderArrows'

/**
 * The "1 of 9" counter and its two arrows, sitting above a slider.
 *
 * Shared by the features slider and the reviews section so the two are the
 * same control rather than two drawings of it. The arrows are the app's own
 * chevrons, not lucide's: heavier, and cut to the same 24-box as the rest of
 * the drawn icons here.
 */
export function SliderNav({
  current,
  total,
  onPrevious,
  onNext,
  counterLabel,
  previousLabel,
  nextLabel,
}: {
  /** Zero-based. */
  current: number
  total: number
  onPrevious: () => void
  onNext: () => void
  /** Already-formatted, e.g. "1 of 9". */
  counterLabel: string
  previousLabel: string
  nextLabel: string
}) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-xl">{counterLabel}</span>

      <SliderArrows
        current={current}
        total={total}
        onPrevious={onPrevious}
        onNext={onNext}
        previousLabel={previousLabel}
        nextLabel={nextLabel}
      />
    </div>
  )
}
